import { Icon } from '../../../components/icons'
import { ErrorType } from './lib'
export class PartnerMisconfigurationError extends Error {
  constructor(message: string) {
    super(message)
    this.name = ErrorType.PartnerMisconfiguration
  }
}

export class InternalMisconfigurationError extends Error {
  constructor(message: string) {
    super(message)
    this.name = ErrorType.InternalMisconfiguration
  }
}

export function ErrorFallbackComponent(props: { error: Error }) {
  const { error } = props
  switch (error.name) {
    case ErrorType.PartnerMisconfiguration:
      return (
        <ErrorDisplay
          message="This DUPR partner has not correctly configured their payment flow. Please report this issue to their support team."
          error={error}
        />
      )
    case ErrorType.InternalMisconfiguration:
      return (
        <ErrorDisplay message="An internal misconfiguration has occurred. Please contact DUPR support." error={error} />
      )
    default:
      return <ErrorDisplay message="An unknown error has occurred. Please try again later." error={error} />
  }
}

export function ErrorDisplay({ message, error }: { message: string; error: Error }) {
  console.error(error)
  return (
    <div className="flex flex-row xs:px-8 xs:py-4 md:py-8 xs:w-full sm:w-[30rem] text-xs gap-x-2 items-center bg-white rounded-sm">
      <div className="w-10 h-10">
        <Icon height="34" width="32" name="ErrorRoundedIcon" className="text-red" color="crimson" />
      </div>
      <div className="p-4">
        <p>{message}</p>
        <p className="text-[#757895] py-4">Error: {error.message}</p>
      </div>
    </div>
  )
}
